import axios from "axios";
import react, { useEffect, useState, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Header from "../sharedFiles/header/header";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUser,
  setCart,
  selectCustomer,
  logoutUser,
  AddOpprId,
  selectOpprID,
  emptyCart,
} from "../ReduxStore/userReducer";
import "./itemPage.css";
import { IconButton, TextField, Tooltip } from "@mui/material";
import { GetData } from "../API/getApi";
import {
  CustomerDataApi,
  GetCRMForSQ,
  getItem,
  getItembySearch,
  getItembySearchWithTotal,
  GetPriceList,
  PostCartItemApi,
  PostCustomerAndOpp,
  removeItemInTable,
  UpdateGreeterStatus
} from "../API/API";
import TablePagination from "@mui/material/TablePagination";
import * as React from "react";
import SunspotLoader from "../sharedFiles/loader/loader";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import SalesQuotationModal from "../salesQuotationModal/salesQuotationModal";
import SideBar from "../sharedFiles/sideBar/SideBar";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CustomizedBadges from "../sharedFiles/cartBadge/cartBadge";
import Swal from "sweetalert2";
import TurnedInNotOutlinedIcon from "@mui/icons-material/TurnedInNotOutlined";
import TurnedInOutlinedIcon from "@mui/icons-material/TurnedInOutlined";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import Footer from "../sharedFiles/footer/footer";
import { useOutsideAlerter } from "../sharedFiles/dropdownCloser/dropdownCloser";
import { fetchCart } from "../ReduxStore/reduxThunk";
import { CRMPostData, resetCrmData, resetItemGroup, resetItems } from "../ReduxStore/actions";
import SharedCrm from "../sharedFiles/sharedCrm/sharedCrm";
import { toast, ToastContainer } from "react-toastify";
import { PostData, PostWithoutData } from "../API/postApi";
import { validateForm } from "../sharedFiles/validateForm";
import dayjs from "dayjs";
import { GetGuestCode } from "../API/Greeter/GreeterThunk";
import { useSharedCrm } from "./sharedCrmContext";
// import { CustomCheckbox } from "../sharedFiles/customCheckbox/customCheckBox";

const ItemPage = () => {

  const ItemGroup = useSelector((state) => state.item.itemGroup);
  const [groupCode, setGroupCode] = useState("");
  const [itemData, setItemData] = useState([]);
  const [displayedItem, setDisplayedItem] = useState([]);
  const GetOpprId = useSelector(selectOpprID);
  const userData = useSelector(selectUser);
  const userId = userData?.UserId;
  const databaseName = userData?.DatabaseName;
  const jwtToken = userData?.JwtToken;
  const { CustomerMaster } = useSelector((state) => state.CustomerMaster);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [itemSearchTerm, setItemSearchTerm] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [cartUpdated, setCartUpdated] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [priceList, setPriceList] = useState(null);
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [cart, setCartItems] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(12);
  const [showItems, setShowItems] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 650);
  const [PriceListShow, setPriceListShow] = useState(false);
  const [pagaValue, setPageValue] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  // const crmPostData = useSelector((state) => state.item.CRMPostData);
  const location = useLocation();
  const { additionalData, opportunityNos } = location.state || {};
  const addData = JSON.parse(localStorage.getItem('additionalData'))
  const linedata = JSON.parse(localStorage.getItem('DocEntry'));
  const orderNumber = linedata?.Order_No;
  const [requiredArea, setRequiredArea] = useState(''); // State to store the area entered by the user
  const [calculatedTiles, setCalculatedTiles] = useState(0);
  const { formData, setFormData, validateForm, initialFormData, setSearchTerm, calculateClosingDate, setSearchValue } = useSharedCrm();
  console.log("formData", formData);

  // useEffect(() => {
  //   if (!cart || Object.keys(cart).length === 0) return
  //   if (formData.LeadLevel && formData.LeadLevel !== "") return
  //   const levels = Object.values(cart)
  //     .map((item) => item.lead_Level)
  //     .filter((level) => level && level !== null && level !== "")
  //   if (levels.length === 0) return
  //   const highestLevel = [...levels].sort()[0]
  //   setFormData((prev) => ({
  //     ...prev,
  //     LeadLevel: highestLevel,
  //   }))
  // }, [cart,formData.existingcust==="NO"])
  useEffect(() => {
    if (!cart || Object.keys(cart).length === 0) return;
    // Trigger only when existing customer is NO
    if (formData.existingcust !== "NO") return;

    if (formData.LeadLevel && formData.LeadLevel !== "") return;

    const levels = Object.values(cart)
      .map((item) => item.lead_Level)
      .filter((level) => level);

    if (levels.length === 0) return;

    const highestLevel = [...levels].sort()[0];

    setFormData((prev) => ({
      ...prev,
      LeadLevel: highestLevel,
    }));
  }, [cart, formData.existingcust]);

  // useEffect(() => {
  //   // if (!cart || Object.keys(cart).length === 0) return

  //   const totalValue = Object.values(cart).reduce((sum, item) => {
  //     const price = item?.defaultPriceList || 0
  //     const qty = item.quantity || 0
  //     return sum + (price * qty)
  //   }, 0)
  //   if (totalValue > 0) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       EstimatedValue: String(totalValue)
  //     }))
  //   }else{
  //     setFormData((prev) => ({
  //       ...prev,
  //       EstimatedValue:""
  //     }))
  //   }

  // }, [cart])
  useEffect(() => {
    const totalValue = Object.values(cart).reduce((sum, item) => {
      const price = item?.defaultPriceList || 0;
      const qty = item.quantity || 0;
      return sum + price * qty;
    }, 0);

    setFormData((prev) => ({
      ...prev,
      EstimatedValue: totalValue > 0 ? String(totalValue) : "",
    }));
  }, [cart]);
  useEffect(() => {
    const fetchCustomerData = async () => {
      if (opportunityNos && jwtToken) {
        try {
          const newData = await GetData(
            `${GetCRMForSQ}${databaseName}&OpprId=${opportunityNos}`, // Make sure to pass opportunityNo in the API URL
            {
              headers: {
                wg_token: jwtToken,
              },
            },
            dispatch,
            navigate
          );
          dispatch(AddOpprId(opportunityNos));
          const closingdate = calculateClosingDate(newData.item1[0]?.requirement_Type)
          let updatedFormData = {
            ...formData,
            PhoneNo: newData.item1[0]?.mobile_Number,
            CustomerName: newData.item1[0]?.customer_Name,
            CustomerCode: newData.item1[0]?.customer_Code,
            // Check if item1 exists and add relevant values to formData
            WalkInType: newData.item1[0]?.walk_In_Type || formData.WalkInType,
            Reference: newData.item1[0]?.u_Reference || formData.Reference,
            LeadLevel: newData.item1[0]?.lead_Level || formData.LeadLevel,
            AssignExecutive: newData.item1[0]?.assign_Executive || userData?.UserName,
            ExecutiveId: newData.item1[0]?.slpCode || userData?.slpCode,
            customerCategory: newData.item1[0]?.customer_Category || formData.customerCategory,
            Segment: newData.item3 || formData.Segment,
            PhoneNo: newData.item1[0]?.mobile_Number,
            CustomerProfile: newData.item1[0]?.u_CustProfile || formData.CustomerProfile, // Update accordingly
            SiteType: newData.item1[0]?.site_Type || formData.SiteType,
            CurrentWorkStatus: newData.item1[0]?.current_Work_Status || formData.CurrentWorkStatus,
            ExpectedComplationOfWork: newData.item1[0]?.completion_Of_Work
              ? dayjs(newData.item1[0]?.completion_Of_Work, 'DD/MM/YYYY').isValid()
                ? dayjs(newData.item1[0]?.completion_Of_Work, 'DD/MM/YYYY').toISOString() // Store as an ISO string
                : formData.ExpectedComplationOfWork
              : formData.ExpectedComplationOfWork,
            ItemsChecked: newData.item2 || formData.ItemsChecked, // Assuming the item name for checkbox
            EstimatedValue: newData.item1[0]?.estimate_Value || formData.EstimatedValue,
            ReqType: newData.item1[0]?.requirement_Type || formData.ReqType,
            SiteVist: newData.item1[0]?.u_SiteVisit || formData.SiteVist,
            Address: newData.item1[0]?.site_Address || formData.Address,
            existingcust: "YES",
            GreeterCode: formData?.GreeterCode || "",
            ClosingDate: closingdate
          };
          setFormData(updatedFormData)
          dispatch(CRMPostData(updatedFormData));
          sessionStorage.setItem('CRMPostData', JSON.stringify(updatedFormData));
        } catch (error) {
          console.error('Error fetching customer data:', error);
        }

      }
    };
    if (opportunityNos) {
      fetchCustomerData();
    }
  }, [opportunityNos, jwtToken, databaseName, dispatch, navigate]);

  useEffect(() => {
    if (!opportunityNos) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        AssignExecutive: userData?.UserName || '',
        ExecutiveId: userData?.slpCode || '',
      }));
    }
  }, [opportunityNos])
  const toggleItems = () => {
    if (isMobile) {
      setShowItems(false);
    }
  };
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave this page?";
      event.returnValue = message;
      return message;
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [])

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 650;
      setIsMobile(mobile);
      // Ensure items are shown when not on mobile
      if (!mobile) {
        setShowItems(true);
      }
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const storedCart = localStorage.getItem("cart");
    if (storedCart) {
      const parsedCart = JSON.parse(storedCart);

      const parsedCartArray = Object.values(parsedCart);
      const userCart = parsedCartArray.reduce((obj, item) => {
        // if (item.userId === userId) {
        obj[item.itemCode] = item; // Assuming 'itemCode' is the unique identifier
        // }
        return obj;
      }, {});
      setCartItems(userCart);
    } else {
      // If storedCart is null or undefined, fetch the cart items
      try {
        // if (userId && jwtToken) {
        dispatch(fetchCart(userId, jwtToken));
        setRefreshKey((oldKey) => oldKey + 1);
        // } else {
        // }
      } catch (error) { }
    }
  }, [refreshKey]);
  // const getGreeterCodeFromSession = () => {
  //   try {
  //     const sessionKeys = ["CRMPostData"];

  //     for (const key of sessionKeys) {
  //       const data = sessionStorage.getItem(key);
  //       if (data) {
  //         const parsed = JSON.parse(data);
  //         if (parsed?.GreeterCode) {
  //           return parsed.GreeterCode;
  //         }
  //       }
  //     }

  //     return null;
  //   } catch (err) {
  //     console.error("Error reading GreeterCode from session:", err);
  //     return null;
  //   }
  // };


  const postGreeterStatus = async () => {
    // const greeterCode = getGreeterCodeFromSession();
    const greeterData = JSON.parse(sessionStorage.getItem("CRMPostData") || '{}');
    if (!greeterData) {
      return;
    }
    const apiUrl = `${UpdateGreeterStatus}?guestCode=${greeterData.GreeterCode}`;
    try {
      const response = await PostData(apiUrl, null, jwtToken, dispatch, navigate);
    } catch (error) {
      console.error("Failed to update greeter status:", error);
    }
  };


  /******* intial call for itemgroup and items  ******/
  useEffect(() => {
    if (ItemGroup && ItemGroup.length > 0) {
      let group = ItemGroup[0].itmsGrpCod;
      setGroupCode(group);
    }
    fetchData();
  }, [ItemGroup]);

  // Update local storage on cart change
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  //*****************end of customer search function *********/
  const handleGroupCodeChange = (groupCode) => {
    setGroupCode(groupCode);
    fetchData(groupCode);
  };
  const fetchData = async (code) => {
    // if (Array.isArray(Item) && groupCode) {
    // const ItemFilteredData = await Item?.filter(
    //   (item) => item.itmsGrpCod && item.itmsGrpCod === groupCode
    // );
    const setGroupCode = code || groupCode
    setPageValue(false);
    setItemSearchTerm("");
    try {
      setIsLoading(true);
      if (userId && jwtToken && setGroupCode) {
        const ItemMaster = await GetData(
          `${getItem}${setGroupCode}&DatabaseName=${databaseName}`,
          {
            headers: {
              wg_token: jwtToken,
            },
          },
          dispatch,
          navigate
        );
        setItemData(ItemMaster);
        setPage(0);
        setRowsPerPage(12);
        setIsLoading(false);
      }
    } catch (err) {
      // setError(err);
    } finally {
      // setLoading(false);
    }
    // setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [groupCode]);

  //***********used for capitalize a words for use this just call "capitalizeWords" */
  const capitalizeWords = (text) => {
    return text
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const calculateTiles = (area, tileArea) => {
    const numberOfTiles = Math.ceil(area / tileArea); // Round up to the nearest whole number
    return numberOfTiles; // Return the calculated value
  };

  // Handle input change for required area (square feet)
  const handleAreaChange = (item, e) => {
    const value = e.target.value;
    // Regular expression to match only numbers (including decimal points)
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
      setRequiredArea(value); // Update the required area state
      const areaValue = parseFloat(value); // Parse the value to a float
      if (!isNaN(areaValue) && areaValue > 0) {
        const tilesRequired = calculateTiles(areaValue, item.sq_Ft); // Calculate the number of tiles
        // setCalculatedTiles((prevState) => ({
        //   ...prevState,
        //   [item.itemCode]: tilesRequired, // Store the calculated number of tiles for each item
        // }));
        setItemData((prevItemData) => {
          const newItems = [...prevItemData];
          const itemIndex = newItems.findIndex(items => items.itemCode === item.itemCode);
          newItems[itemIndex] = { ...newItems[itemIndex], quantity: tilesRequired };
          return newItems;
        });
        updateCart(item.itemCode, tilesRequired); // Update the cart with the calculated quantity
      } else {
        setCalculatedTiles((prevState) => ({
          ...prevState,
          [item.itemCode]: 0, // Reset the calculated tiles if the area is invalid
        }));
        updateCart(item.itemCode, 0); // Remove item from cart if invalid area value
      }
    }
  };
  //********* add a new item to cart *********************/
  const handleAddCart = (itemCode) => {
    setItemData((prevItemData) => {
      const newItems = [...prevItemData];
      const itemIndex = newItems.findIndex(item => item.itemCode === itemCode);
      if (itemIndex >= 0) {
        newItems[itemIndex] = { ...newItems[itemIndex], quantity: 1 };
      }
      return newItems;
    });
    setCartUpdated(true);
    updateCart(itemCode, 1); // Update the cart with the new quantity
  };
  //***************** it increment a quantity of item in a cart *************/
  const incrementQuantity = (itemCode) => {
    setItemData((prevItemData) => {
      const newItems = [...prevItemData];
      const itemIndex = newItems.findIndex(item => item.itemCode === itemCode); // Find item by itemCode
      const currentQuantity = newItems[itemIndex].quantity || cart[itemCode]?.quantity || 0;

      newItems[itemIndex] = { ...newItems[itemIndex], quantity: currentQuantity + 1 }; // Increment quantity
      return newItems;
    });

    setCartUpdated(true);
    updateCart(itemCode, (cart[itemCode]?.quantity || 0) + 1); // Update cart with incremented quantity
  };
  //********************* Decrement a quantity of item in the cart ***********/
  const decrementQuantity = (itemCode) => {
    setItemData((prevItemData) => {
      const newItems = [...prevItemData];
      const itemIndex = newItems.findIndex(item => item.itemCode === itemCode); // Find item by itemCode
      const currentQuantity = newItems[itemIndex].quantity || cart[itemCode]?.quantity || 0;

      if (currentQuantity > 0) {
        newItems[itemIndex] = { ...newItems[itemIndex], quantity: currentQuantity - 1 }; // Decrement quantity
      }
      return newItems;
    });

    setCartUpdated(true);
    updateCart(itemCode, (cart[itemCode]?.quantity || 0) - 1); // Update cart with decremented quantity
  };
  //***************** Update a item into cart from here only reflect a item in table ******/


  const updateCart = (itemCode, newQuantity) => {

    setItemData((prevItemData) => {
      const newItems = [...prevItemData];
      const item = newItems.find(item => item.itemCode === itemCode);
      if (item) {
        const currentQuantity = item.quantity || cart[itemCode]?.quantity;
        const newCart = { ...cart };

        if (newQuantity <= 0) {
          delete newCart[itemCode]; // Remove item from cart if new quantity is zero or negative
        } else {
          newCart[itemCode] = { ...item, quantity: currentQuantity }; // Add item to cart with updated quantity
        }

        setCartItems(newCart);
      }

      return newItems;
    });
  };
  /******************* Remove a item from cart  ********************/
  const handleRemoveItem = (itemCode) => {
    setItemData((prevItemData) => {
      const newItems = [...prevItemData];
      const itemIndex = newItems.findIndex(item => item.itemCode === itemCode); // Find item by itemCode
      newItems[itemIndex] = { ...newItems[itemIndex], quantity: 0 }; // Set quantity to 0

      return newItems;
    });

    setCartUpdated(true);
    updateCart(itemCode, 0); // Remove item from cart by setting quantity to 0
  };
  /************** Handle input value changes in input field **************/
  const handleInputChange = (itemCode, event) => {
    const value = event.target.value.trim(); // Remove leading and trailing whitespace

    if (value === "") {
      setItemData((prevItemData) => {
        const newItems = [...prevItemData];
        const itemIndex = newItems.findIndex(item => item.itemCode === itemCode); // Find item by itemCode
        newItems[itemIndex] = { ...newItems[itemIndex], quantity: 1 }; // Set quantity to 1 if input is empty
        return newItems;
      });

      setCartUpdated(true);
      updateCart(itemCode, 1); // Update cart with quantity 1
    } else {
      const newQuantity = parseInt(value);
      if (!isNaN(newQuantity)) {
        setItemData((prevItemData) => {
          const newItems = [...prevItemData];
          const itemIndex = newItems.findIndex(item => item.itemCode === itemCode); // Find item by itemCode
          newItems[itemIndex] = { ...newItems[itemIndex], quantity: newQuantity };
          return newItems;
        });

        setCartUpdated(true);
        updateCart(itemCode, newQuantity); // Update cart with new quantity
      }
    }
  };
  //******* This will helps to find a item by input search ********/
  const fetchSearchData = async () => {
    if (itemSearchTerm.length > 2) {
      setPageValue(true);
      try {
        const response = await GetData(
          `${getItembySearchWithTotal}${itemSearchTerm}&databaseName=${databaseName}&pageNumber=${page + 1
          }&pageSize=${rowsPerPage}`,
          {
            headers: {
              wg_token: jwtToken,
            },
          },
          dispatch,
          navigate
        );
        setItemData(response.items)
        setDisplayedItem(response.items);
        setTotalCount(response.totalCount);
        // setPage(0); // Reset page on new search
      } catch (error) {
        console.error("Search Data Fetch Error:", error);
      }
    } else {
      setPageValue(false);
      setDisplayedItem([]);
      setPage(0);
    }
  };
  const handleItemInputChange = async (e) => {
    const value = e.target.value;
    setItemSearchTerm(value);
    setPage(0); // Reset page on new search

    if (value.length > 2) {
      fetchSearchData();
    } else {
      if (value.length > 0) {
        setDisplayedItem([]);
      } else {
        fetchData();
        setPageValue(false);
      }
    }
  };
  //******This will help to process a checkout click *********/
  const handleCheckout = async (value, shouldNavigate) => {
    if (!shouldNavigate && value === "CRM Post") {
      if (!formData.ItemsChecked || formData.ItemsChecked.length === 0) {
        toast.warning("You must check at least one item before submitting.", {
          position: "bottom-right",
          theme: "dark",
        });
        return; // Stop further execution
      }
      setIsLoading(true);
      const updatedFormData = {
        ...formData,
        ExecutiveId: formData.ExecutiveId || "-1",
        EstimatedValue: formData.EstimatedValue || 1000,
      };


      const dataToSend = {
        companyName: databaseName,
        customerData: {
          customerName: formData?.CustomerName,
          mobileNumber: formData?.PhoneNo,
          cardCode: formData?.CustomerCode
        },
        post: [updatedFormData],
        entryType: formData.existingcust,
      };
      try {
        const responseData = await PostData(
          PostCustomerAndOpp,
          dataToSend,
          jwtToken,
          dispatch,
          navigate
        );
        if (responseData === "OK") {
          const greeterData = JSON.parse(sessionStorage.getItem("CRMPostData") || '{}');
          if (greeterData.GreeterCode) {
            const apiUrl = `${UpdateGreeterStatus}?guestCode=${greeterData.GreeterCode}`;
            const response = await PostData(apiUrl, null, jwtToken, dispatch, navigate);
            if (response === "OK") {
              // toast.success("CRM successfully created!", {
              //   position: "bottom-right",
              //   theme: "dark",
              // });
            }
          }
          setIsLoading(false);
          setModalShow(false);
          setSearchTerm("");
          setSearchValue("");
          setFormData({
            ...initialFormData,
            AssignExecutive: userData?.UserName || '',
            ExecutiveId: userData?.slpCode || '',
          });
          sessionStorage.removeItem("CRMPostData")
          dispatch(resetCrmData());
          toast("CRM successfully created!", {
            position: "bottom-right",
            theme: "dark",
          });
        } else {
          setIsLoading(false);
          toast(responseData, {
            position: "bottom-right",
            theme: "dark",
          });
        }
      } catch (error) {
        setIsLoading(false);
        toast(error.message, {
          position: "bottom-right",
          theme: "dark",
        });
      }

      return;
    }
    let userCart = Object.fromEntries(
      Object.entries(cart).map(([key, item]) => {
        let newItem = { ...item, userId }; // Create a new object
        if (!newItem.salUnitMsr) {
          newItem.salUnitMsr = "0"; // If salUnitMsr will be empty means it will render 0
        }
        if (!newItem.defaultPriceList) {
          newItem.defaultPriceList = 0;
        }
        return [key, newItem];
      })
    );
    //****** This will helps to check cart item quantity have value and only a number *********/
    const validatedCart = Object.fromEntries(
      Object.entries(userCart).filter(([key, item]) =>
        Number.isInteger(item.quantity)
      )
    );
    if (Object.keys(validatedCart).length === 0) {
      toast.warning("Cart is empty. Please add items before checkout.", {
        position: "bottom-right",
        theme: "dark",
      });
      return;
    }
    //********* Here will convert a validated abject into array *********/
    const validatedCartArray = Object.values(validatedCart);
    setIsLoading(true);
    // Dispatch the validated cart to Redux
    dispatch(setCart(validatedCart));
    // Save the validated cart to local storage
    localStorage.setItem("cart", JSON.stringify(validatedCart));
    try {
      const responseData = await axios.post(
        PostCartItemApi + "userId=" + userId,
        validatedCartArray,
        {
          headers: {
            wg_token: jwtToken,
          },
        }
      );
      setCartUpdated(false);
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 401 ||
          error.response.data === "Invalid token")
      ) {
        dispatch(logoutUser());
        dispatch(resetItemGroup());
        dispatch(resetItems());
        localStorage.removeItem("cart")
        navigate("/");
      }
    }
    setIsLoading(false);
    if (shouldNavigate) {
      navigate("/Checkout", { state: { orderType: value } }); // Here will navigate to checkout page with the values for posting to sales order or sales quatation
    } else {
      Swal.fire("Cart updated successfully!");
      setIsLoading(false);
    }
  };

  const handleManualPrice = (event, itemCode) => {
    let rawValue = event.target.value.replace(/[^\d.]/g, ''); // Remove non-numeric characters except the decimal point.

    // If the user typed something empty (or deleted everything), just return without doing anything
    if (rawValue === '') {
      setCartItems((prevCart) => {
        const newCart = { ...prevCart };
        if (newCart[itemCode]) {
          newCart[itemCode] = {
            ...newCart[itemCode],
            defaultPriceList: "", // Set to empty string if cleared
          };
        }
        return newCart;
      });

      setItemData((prevItemData) => {
        return prevItemData?.map((item) => {
          if (item.itemCode === itemCode) {
            return {
              ...item,
              defaultPriceList: "", // Set to empty string if cleared
            };
          }
          return item;
        });
      });
      return;
    }

    // Ensure that the number has at most 2 decimal places.
    if (rawValue.indexOf('.') !== -1) {
      const parts = rawValue.split('.');
      if (parts[1].length > 2) {
        rawValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
      }
    }
    // If value is valid, parse it as a float and save
    const parsedValue = parseFloat(rawValue);
    if (!isNaN(parsedValue)) {
      setCartItems((prevCart) => {
        const newCart = { ...prevCart };
        if (newCart[itemCode]) {
          newCart[itemCode] = {
            ...newCart[itemCode],
            defaultPriceList: rawValue, // Store the value as a number
          };
        }
        return newCart;
      });


      setItemData((prevItemData) => {
        return prevItemData?.map((item) => {
          if (item.itemCode === itemCode) {
            return {
              ...item,
              defaultPriceList: rawValue, // Store the value as a string.
            };
          }
          return item;
        });

      });
    }
  };



  //********* This is for shows the sales order or sales quatation choosing modal ********/
  const handleIconClick = () => {
    setModalShow(true);
  };

  //********* This will helps to get a price list for each item *********/
  const handlePriceList = async (itemCode) => {
    setSelectedItemCode(itemCode);
    try {
      const response = await GetData(
        GetPriceList + itemCode + "&databaseName=" + databaseName,
        {
          headers: {
            wg_token: jwtToken,
          },
        }
      );
      setPriceList(response);
      if (response) {
        setPriceListShow(true);
      }
    } catch (error) { }
  };

  //******** This is use for click outside of to the price dropdown it will close that dropdown **********/
  const wrapperRef = React.useRef(null);
  useOutsideAlerter(wrapperRef, () => setPriceListShow(false)); // This is external component will it anywhere for while clicking outside to dropdown it will close

  //******** This will helps to choose the price from the price list dropdown **********/
  const handlePriceClick = (priceItem, itemCode) => {

    setCartItems((prevCart) => {
      // Create a copy of the current cart
      const newCart = { ...prevCart };

      // Check if the item exists in the cart
      if (newCart[itemCode]) {
        // Update the item's defaultPriceList and add priceListName
        newCart[itemCode] = {
          ...newCart[itemCode],
          defaultPriceList: priceItem.unitPrice, // Update the unit price
          priceListName: priceItem.priceList, // Add the price list name
        };
      }
      return newCart;
    });

    setItemData((prevItemData) => {
      const newItems = prevItemData.map((item) => {
        if (item.itemCode === itemCode) {
          return {
            ...item,
            defaultPriceList: priceItem.unitPrice,
            priceListName: priceItem.priceList,
          };
        }
        return item;
      });
      return newItems;
    });

    setPriceListShow(false);
  };

  //******** Pagination function will start here *************/
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  //   SlicedItem();
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  //   SlicedItem();
  // };

  // const SlicedItem = () => {
  //   if (itemData && itemData.length > 0 ) {
  //   setDisplayedItem(
  //   itemData
  //   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))}
  // }
  useEffect(() => {
    SlicedItem(page, rowsPerPage);
  }, [page, rowsPerPage, itemData]);

  useEffect(() => {
    if (itemSearchTerm.length > 2) {
      fetchSearchData();
    }
  }, [itemSearchTerm, page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const SlicedItem = (page, rowsPerPage) => {
    setIsLoading(true);
    if (itemData && itemData.length > 0) {
      if (!itemSearchTerm) {
        setDisplayedItem(
          itemData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        );
      }
      else {
        setDisplayedItem(itemData);
      }
    }
    setIsLoading(false);
  };


  //********** Pagination function will end here ************/

  //********** This will helps to calculate a overall quantity of items in cart ********/
  // const getTotalQuantity = () => {
  //   return Object.values(cart).reduce((total, item) => {
  //     const currentQuantity = item.quantity || 0;
  //     return total + currentQuantity;
  //   }, 0);
  // };
  const getNumberOfItems = () => {
    return Object.keys(cart).length;
  };

  const handleRemoveTableItem = async (event) => {
    const removeData = await PostWithoutData(
      `${removeItemInTable}userId=${userId}`,
      jwtToken,
      dispatch,
      navigate
    );
  };
  const handleBackNav = () => {

    if (addData?.additionalData === 'sqUpdate') {
      dispatch(AddOpprId(""));
      dispatch(emptyCart());
      handleRemoveTableItem();
      dispatch(resetCrmData());
      localStorage.removeItem('additionalData');
      localStorage.removeItem('DocEntry');
      localStorage.removeItem('customerDatas');
      navigate('/SqHistory');
    } else {
      navigate("/DashBoard");
      setSearchTerm("");
      // setCustomerName("");
    }
  };

  const handleNavOppor = () => {
    dispatch(AddOpprId(""));
    navigate("/CustomerFollowups");
  }


  //******** This the default funtion if userdata not there means it navigate to login page **********/
  if (!userData || !userData.UserName) {
    return <Navigate to="/" />;
  }

  return (
    <>
      {/* <button onClick={handleLogout}>logout</button> */}
      <Header
        ItemInputChange={handleItemInputChange}
        show={"show"}
        itemSearchTerm={itemSearchTerm}
      />
      <div className='dashBoardMain'>
        <div className="dashImage"></div>
        <div className="backIconDiv">
          {additionalData === "OpporItemPage" && GetOpprId !== "" ? (
            <div className="d-flex col-4 me-4 me-xl-5 me-xxl-4 col-xl-5 col-xxl-5">
              <button onClick={handleNavOppor} className="backIcondiv">
                <ArrowCircleLeftIcon />
                <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">Opportunity Item Page</p>
              </button>
            </div>
          ) :
            (
              <div className="d-flex col-4 me-4 me-xl-5 me-xxl-4 col-xl-5 col-xxl-5">

                <button onClick={handleBackNav} className="backIcondiv">
                  <ArrowCircleLeftIcon />
                  <span className="DashBoardName" >Dashboard</span>
                </button>
              </div>
            )}

          <div className=" d-flex align-items-center">
            <div className="customerDiv col-8 col-xl-8">
              {/* <TextField
                type="text"
                label="Customer Name"
                className="checkCust"
                value={searchTerm || ""}
                
                onClick={handleInputClick}
                onChange={handleCustInputChange}
                variant="standard"
                autoComplete="off"
                disabled={formData.existingcust === "NO"}
              />
              {console.log("searchTerm",searchTerm)}
              {isDropdownVisible && searchTerm && (
                <ul className="binUl">
                  {filteredData.length > 0 ? (
                    filteredData.map((item, index) => (
                      <li
                        key={index}
                        onClick={() => handleItemClick(item)}
                      >
                        {item.customerCode} - {item.customerName}
                      </li>
                    ))
                  ) : (
                    <li>No customer found</li>
                  )}
                </ul>
              )} */}

              {addData?.additionalData === 'sqUpdate' &&

                // <div className="customerDiv col-8 col-xl-8">
                <TextField
                  type="text"
                  label="OrderNo"
                  className="checkCust"
                  value={orderNumber}
                  variant="standard"
                  autoComplete="off"
                  // disabled={customerYes === "NO"}
                  disabled
                />
                // </div>
              }
            </div>

            <Tooltip title="Preview Items">
              <IconButton onClick={toggleItems}>
                <PreviewOutlinedIcon className="previewIcon saveIcon" />
              </IconButton>
            </Tooltip>
            {cart && cartUpdated ? (
              <Tooltip title="Save for Later">
                <IconButton onClick={() => handleCheckout(false)}>
                  <TurnedInNotOutlinedIcon className="saveIcon" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Cart Saved">
                <IconButton>
                  <TurnedInOutlinedIcon className="saveIcon" />
                </IconButton>
              </Tooltip>
            )}
            <CustomizedBadges
              badgeContent={getNumberOfItems()}
              onClick={handleIconClick}
            />
            <SideBar setGroupCode={setGroupCode} />
          </div>
        </div>
        <div className="ItemPage col-12">
          <div className="d-none d-xxl-flex col-2  flex-column categoryDiv">
            <div className="categoryInsideDiv">
              {ItemGroup && ItemGroup.length > 0 ? (
                ItemGroup.map((group, index) => (
                  <button
                    className="categoryButton mb-auto"
                    key={index}
                    // onClick={() => setGroupCode(group.itmsGrpCod)}
                    onClick={() => handleGroupCodeChange(group.itmsGrpCod)}
                  >
                    {group.itmsGrpNam}
                  </button>
                ))
              ) : (
                <li>No data available</li>
              )}
            </div>
          </div>
          <div className="itemDiv col-12 col-sm-9 col-xl-10 col-md-8 col-xxl-8">
            <div className="gradient col-xl-10 col-8 col-xxl-8"></div>

            <div className="item-inside-div col-12">
              {displayedItem && displayedItem.length > 0 ? (
                displayedItem.map((item, index) => (
                  <div
                    className="itemDataBox position-relative "
                    key={item?.itemCode}
                  >
                    <div className="itemNameDiv">
                      <p className="m-0">
                        {item?.itemName
                          ? capitalizeWords(item?.itemName)
                          : "No Name Available"}
                      </p>
                      <p className="m-0 itemcodeP">{item.itemCode}</p>
                    </div>
                    {/* <div className=""> */}
                    {/* <div className="instock position-absolute d-flex  flex-column "
                >
                  <span>InStock : {item.onHand}</span> 
                </div> */}
                    <div className="Price-data col-xl-12">
                      <div className="unit-div col-6 col-xxl-8 col-xl-8">
                        <div className="unit  col-xxl-5 col-5">
                          <p>
                            InStock :{" "}
                          </p>
                          <p className="d-flex">
                            Unit :{" "}
                          </p>
                          {(item.tileSize && item.tileSize !== "") &&
                            <p className="m-0">
                              Size :{" "}
                            </p>}
                        </div>
                        <div className="valueFont col-7 col-xxl-7">
                          <p >
                            {item.onHand}
                          </p>
                          <p>
                            {item.salUnitMsr}
                          </p>
                          {(item.tileSize && item.tileSize !== "") &&
                            <p className="m-0">
                              {item.tileSize}
                            </p>}
                        </div>
                      </div>
                      <div className="col-xl-4 amountDiv">
                        <div className=" col-12">
                          <input
                            className="form-control amountPosition col-12"
                            value={`₹${cart[item.itemCode]?.defaultPriceList
                              ? cart[item.itemCode].defaultPriceList.toLocaleString()
                              : item.defaultPriceList != null
                                ? item.defaultPriceList.toLocaleString()
                                : 0}`}
                            onClick={(event) => event.target.select()} // Allow user to select the entire value
                            onChange={(event) => handleManualPrice(event, item.itemCode)} // Pass itemCode
                            readOnly={!(item.webPriceEdit === "Yes" || (item.tileSize && item.tileSize !== ""))}
                          />
                        </div>
                        {item.tileSize && item.tileSize !== "" ?
                          <div className=" col-12">
                            <input
                              className="form-control amountPosition"
                              type="text"
                              placeholder="Required sq Feet"
                              value={requiredArea || ''}
                              onChange={(e) => handleAreaChange(item, e)}
                            />
                          </div> : <div></div>}
                      </div>

                    </div>

                    {/* <div className="d-flex col-6">
                          <input
                            className="form-control amountPosition"
                            type="text"
                            placeholder="Required sq Feet"
                            value={requiredArea || ''}
                            onChange={(e) => handleAreaChange(item, e)}
                          />
                        </div> */}

                    {/* </div> */}
                    <TextField
                      // {...params}
                      // label="Price List"
                      className="PriceList"
                      id="standard-basic"
                      variant="standard"
                      onClick={() => handlePriceList(item.itemCode)}
                      value={cart[item.itemCode]?.priceListName
                        ? cart[item.itemCode].priceListName
                        : item.priceListName
                          ? item.priceListName
                          : "MRP"}
                    />
                    {selectedItemCode === item.itemCode &&
                      priceList &&
                      PriceListShow && (
                        <ul className="priceListContainer" ref={wrapperRef}>
                          {priceList.map((priceItem, index) => (
                            <li
                              key={index}
                              className="priceListItem"
                              onClick={() =>
                                handlePriceClick(priceItem, item.itemCode)
                              }
                            >
                              {priceItem.priceList} - {priceItem.unitPrice}
                            </li>
                          ))}
                        </ul>
                      )}

                    {cart[item.itemCode] && cart[item.itemCode].quantity > 0 ? (
                      <>
                        <button className="addTocart" style={{ display: "none" }}>
                          Add to Cart
                        </button>
                        <div className="d-flex ButtonPosition">
                          <div className="counter-buttons col-6">
                            <button
                              className="minus btn-secondary"
                              onClick={() =>
                                decrementQuantity(item.itemCode)
                              }
                            >
                              -
                            </button>
                            <input
                              type="text"
                              className="Qty-Input"
                              value={cart[item.itemCode].quantity}
                              onClick={(event) => event.target.select()}
                              onChange={(event) =>
                                handleInputChange(item.itemCode, event)
                              }

                            // onBlur={() => handleInputBlur(index)}
                            />
                            <button
                              className="plus btn-secondary"
                              onClick={() =>
                                incrementQuantity(item.itemCode)
                              }
                            >
                              +
                            </button>
                          </div>
                          <div className="col-5">
                            <button
                              className="remove-item"
                              onClick={() =>
                                handleRemoveItem(item.itemCode)
                              }

                            >
                              <HighlightOffIcon />
                            </button>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <button
                          className="addTocart"
                          onClick={() => handleAddCart(item.itemCode)}
                        >
                          Add to Cart
                        </button>
                        <div
                          className="counter-buttons"
                          style={{ display: "none" }}
                        >
                          <span className="minus btn-secondary unselectable">
                            -
                          </span>
                          <input
                            type="text"
                            className="count qty"
                            value="1"
                            readOnly
                          />
                          <span className="plus btn-secondary unselectable">
                            +
                          </span>
                        </div>
                      </>
                    )}
                    {/* {showButton && (
        <button onClick={scrollToTop} className="back-to-top">
          &#8679; 
        </button>
      )} */}
                  </div>
                ))
              ) : (
                <div className=" noitem-div">
                  <div className="noitem">
                    <div className="noItemIcon"></div>
                    <p className="noItemIcon-text">
                      Oops! There is no Item avaliable with this name"
                      <span>
                        {itemSearchTerm.length > 2 ? itemSearchTerm : ""}
                      </span>
                      "!
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="item-checkout-div col-2 col-sm-3">
            {(isMobile && showItems) || !isMobile ? (
              <div className="ItemList col-sm-10">
                <p>Checkout Item List</p>
                <div className="checkoutListDiv">
                  {Object.keys(cart).map((keys, index) => {
                    const item = cart[keys];
                    return (
                      <div key={item.itemCode} className="checkoutList">
                        {index + 1}. {item.itemCode}-{item.itemName} *{" "}
                        {item.quantity}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}
            {/* <p>Quantity <span>{getTotalQuantity()}</span></p> */}
            <div className="CheckOutDiv col-6 col-xl-12">
              <button
                onClick={() => {
                  if (!validateForm()) {
                    setModalShow(false);
                    toast.warning("Please fill all required Fields", {
                      position: "bottom-right",
                      theme: "dark",
                    });
                    return;
                  }
                  setModalShow(true);
                }}
                className="CheckOutButton"
              >
                <ShoppingCartCheckoutIcon />
                Checkout{" "}
              </button>
              <button
                className="CheckOutButton"
                onClick={() => handleCheckout(false)}
              >
                Save for Later
              </button>
            </div>
            <div className="sharedDiv">
              <SharedCrm
                // formData={formData}
                // setFormData={setFormData}
                // errorCount={errorCount}
                customer={CustomerMaster && CustomerMaster}

              />
            </div>
          </div>
        </div>
        <div>
          <SalesQuotationModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            handlecheckout={handleCheckout}
            isLoading={isLoading}
            isdropdownvisible={isDropdownVisible ? "true" : undefined}
          />

        </div>
        {isLoading && (
          <div className="loader position-absolute ">
            <SunspotLoader />
          </div>
        )}
        <div className="pagination">
          <TablePagination
            component="div"
            count={pagaValue ? (isNaN(totalCount) ? 0 : totalCount) : (itemData?.length || 0)} // Use the length of the item data
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[12, 24, 48]}
          />
        </div>
      </div>
      <ToastContainer />
      <Footer />
    </>
  );
};
export default ItemPage;
